import { render, staticRenderFns } from "./orderTake.vue?vue&type=template&id=5a6b1200&scoped=true"
import script from "./orderTake.vue?vue&type=script&lang=js"
export * from "./orderTake.vue?vue&type=script&lang=js"
import style0 from "./orderTake.vue?vue&type=style&index=0&id=5a6b1200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b1200",
  null
  
)

export default component.exports